import React from "react";
import { Navigate, useParams } from "react-router-dom";

const canonicalRoutes = {
  "permanent-staffing": "/PermanentStaffing",
  "temporary-staffing": "/TemporaryStaffing",
  "payroll-management": "/PayRoll",
  "dedicated-it": "/DedicatedIt",
  "international-recruitment": "/International",
  "executive-search": "/Executive",
  "bulk-hiring": "/BulkHiring",
  "visa-assistance": "/VisaAssistance"
};

function ServiceDetails() {
  const { serviceId } = useParams();
  return <Navigate replace to={canonicalRoutes[serviceId] || "/Services"} />;
}
export default ServiceDetails;
